import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { ReactElement } from 'react';
import api from '../api/api';

interface ProtectedRouteProps {
  children: ReactElement;
  featureKey?: string; // ключ фичи из limits.features
  blockedForFree?: boolean; // заблокировано для free-уровня
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, featureKey, blockedForFree }) => {
  const auth = useContext(AuthContext);
  const [allowed, setAllowed] = useState<boolean | null>(null); // null = проверка

  useEffect(() => {
    const checkFeature = async () => {
      if (!auth?.isAuthenticated) {
        setAllowed(false);
        return;
      }
      if (!featureKey && !blockedForFree) {
        setAllowed(true); // фича не ограничена
        return;
      }

      try {
        const res = await api.get('/subscriptions/limits');

        // Блокируем для free-уровня
        if (blockedForFree && res.data.user_level === 'free') {
          setAllowed(false);
          return;
        }

        if (featureKey) {
          const isAvailable = res.data.features[featureKey] === true;
          setAllowed(isAvailable);
        } else {
          setAllowed(true);
        }
      } catch (err) {
        setAllowed(false);
      }
    };
    checkFeature();
  }, [auth, featureKey, blockedForFree]);

  // пока проверяем лимиты — можно вернуть null или loader
  if (allowed === null) return null;

  if (!auth?.isAuthenticated) return <Navigate to="/login" />;
  if (featureKey && !allowed) return <Navigate to="/accounts" />; // редирект если фича недоступна

  return children;
};

export default ProtectedRoute;